import { Component, computed, inject } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { sharedImports } from '../../sharedImports';
import { ArtButtonComponent } from '../art-button/art-button.component';
import { MsalService } from '@azure/msal-angular';
import { UserStore } from '@stores/user.store';
import { PermissionService } from '@services/permission.service';
import { RolesDTO } from '@api';

@Component({
  selector: 'art-app-header',
  imports: [sharedImports, ArtButtonComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  providers: [provideTranslocoScope('header')],
})
export class HeaderComponent {
  private authService = inject(MsalService);
  protected userStore = inject(UserStore);
  protected permissionService = inject(PermissionService);

  protected readonly RolesDTO = RolesDTO;

  loggingOut = false;

  userName = computed(() => {
    const user = this.userStore.user();
    if (!user) {
      console.error('Undefined user in header component.');
      return '';
    }
    return user.context?.name ?? user.name;
  });

  onLogout() {
    this.loggingOut = true;
    this.authService.logoutRedirect();
  }
}
